import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  imageUrl: string;
  date: string;
  readTime: string;
  categoryName: string;
  tags?: string[];
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  imageUrl,
  date,
  readTime,
  categoryName,
  tags,
}: ArticleCardProps) {
  return (
    <Link
      to={`/article/${slug}`}
      className="group block bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:scale-[1.02]"
    >
      <div className="relative w-full h-52 overflow-hidden">
        <img
          src={imageUrl}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-3 left-3 px-3 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full">
          {categoryName}
        </span>
      </div>
      <div className="p-5">
        <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
          {title}
        </h3>
        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-4">
          {excerpt}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-500">
          <div className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <i className="ri-calendar-line"></i>
              {date}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-time-line"></i>
              {readTime}
            </span>
          </div>
        </div>
        {tags && tags.length > 0 && (
          <div className="flex flex-wrap gap-1.5 mt-3 pt-3 border-t border-background-200">
            {tags.slice(0, 3).map((tag) => (
              <span
                key={tag}
                className="px-2 py-0.5 bg-background-100 text-foreground-600 text-xs rounded"
              >
                #{tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </Link>
  );
}